import React from 'react';
import { Link } from 'react-router-dom';
import { TrendingUp } from 'lucide-react';
export function TravelDeals() {
  return <div className="w-full bg-gray-50 min-h-screen" data-id="element-2293">
      {/* Hero Banner */}
      <div className="relative h-[300px] sm:h-[400px] overflow-hidden" data-id="element-2294">
        <div className="absolute inset-0 bg-cover bg-center" style={{
        backgroundImage: 'url(https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1920&h=400&fit=crop&auto=format&q=80)'
      }} data-id="element-2295">
          <div className="absolute inset-0 bg-gradient-to-r from-[#0E578E]/95 via-[#0E578E]/90 to-[#01AAE7]/85" data-id="element-2296"></div>
        </div>

        <div className="absolute inset-0" data-id="element-2297">
          <div className="absolute inset-0 opacity-5" style={{
          backgroundImage: `linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)`,
          backgroundSize: '50px 50px'
        }} data-id="element-2298"></div>
        </div>

        <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 flex items-center justify-center" data-id="element-2299">
          <div className="text-center max-w-3xl" data-id="element-2300">
            <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-md text-white px-4 sm:px-5 py-2 sm:py-2.5 rounded-full text-xs sm:text-sm font-bold mb-4 sm:mb-6 border border-white/30 shadow-lg" data-id="element-2301">
              <TrendingUp className="h-3.5 sm:h-4 w-3.5 sm:w-4" data-id="element-2302" />
              Exclusive Travel Benefits
            </div>

            <h1 className="text-4xl sm:text-5xl md:text-6xl font-black text-white mb-3 sm:mb-4 leading-tight drop-shadow-lg px-4" data-id="element-2303">
              We Love to Travel.
            </h1>

            <p className="text-base sm:text-lg md:text-xl text-white/95 leading-relaxed max-w-2xl mx-auto drop-shadow-md px-4" data-id="element-2304">
              Your exclusive travel and lifestyle benefits are within your
              reach.
            </p>
          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0" data-id="element-2305">
          <svg viewBox="0 0 1440 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" data-id="element-2306">
            <path d="M0 48H1440V24C1440 24 1200 0 720 0C240 0 0 24 0 24V48Z" fill="#F9FAFB" data-id="element-2307" />
          </svg>
        </div>
      </div>

      {/* Car Rentals Section */}
      <section className="py-12 sm:py-16 lg:py-24 bg-white" data-id="element-2308">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10" data-id="element-2309">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center" data-id="element-2310">
            {/* Left Column - Text Content */}
            <div className="space-y-6 sm:space-y-8" data-id="element-2311">
              <div data-id="element-2312">
                <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-gray-900 mb-4 sm:mb-6 leading-tight" data-id="element-2313">
                  Car Rentals at a Fraction of the Cost
                </h2>
                <p className="text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed" data-id="element-2314">
                  Get where you need to be for a fraction of the cost with up to
                  25% off over 40,000 global car rental locations and brands
                  like Alamo, Enterprise, National, Avis, and Budget.
                </p>
              </div>

              <div className="pt-4 sm:pt-6 border-t-2 border-gray-200" data-id="element-2315">
                <h3 className="text-2xl sm:text-3xl font-black text-gray-900 mb-4 sm:mb-6" data-id="element-2316">
                  Of the Cost
                </h3>
                <div className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed space-y-3 sm:space-y-4" data-id="element-2317">
                  <p data-id="element-2318">
                    Get where you need to be for a fraction of the cost with up
                    to 25% off over 40,000 global car rental locations and
                    brands like Alamo, Enterprise, National, Avis, and Budget.
                    Plus, you can book stress-free with cancellations on most
                    rentals up to 48 hours before pick up and pay later options.
                  </p>
                  <p data-id="element-2319">
                    Login, click the "Cars" tab, type in your pick-up
                    destination, and search our deals. Don't have an account its
                    simple click the register button below to gain access.
                  </p>
                  <p data-id="element-2320">
                    Have questions or need help booking? Call{' '}
                    <span className="font-bold text-gray-900" data-id="element-2321">
                      (877) 428-4585
                    </span>{' '}
                    to speak with one of our friendly customer service reps
                    24/7.
                  </p>
                </div>
              </div>

              {/* Info Cards */}
              <div className="grid grid-cols-3 gap-3 sm:gap-4 pt-4 sm:pt-6" data-id="element-2322">
                <div className="bg-gray-50 p-3 sm:p-4 rounded-xl text-center" data-id="element-2323">
                  <div className="text-2xl sm:text-3xl font-black text-[#0E578E] mb-1" data-id="element-2324">
                    25%
                  </div>
                  <div className="text-xs sm:text-sm text-gray-600 font-medium" data-id="element-2325">
                    Savings
                  </div>
                </div>
                <div className="bg-gray-50 p-3 sm:p-4 rounded-xl text-center" data-id="element-2326">
                  <div className="text-2xl sm:text-3xl font-black text-[#0E578E] mb-1" data-id="element-2327">
                    40K+
                  </div>
                  <div className="text-xs sm:text-sm text-gray-600 font-medium" data-id="element-2328">
                    Locations
                  </div>
                </div>
                <div className="bg-gray-50 p-3 sm:p-4 rounded-xl text-center" data-id="element-2329">
                  <div className="text-2xl sm:text-3xl font-black text-[#0E578E] mb-1" data-id="element-2330">
                    24/7
                  </div>
                  <div className="text-xs sm:text-sm text-gray-600 font-medium" data-id="element-2331">
                    Support
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column - Image */}
            <div className="order-first lg:order-last" data-id="element-2332">
              <div className="rounded-xl sm:rounded-2xl overflow-hidden shadow-xl sm:shadow-2xl" data-id="element-2333">
                <img src="https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=800&h=900&fit=crop&auto=format&q=80" alt="Person with map planning travel" className="w-full h-full object-cover" data-id="element-2334" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Endless Destinations Section */}
      <section className="relative min-h-[600px] sm:min-h-screen flex items-center justify-center bg-gray-900 pb-12 sm:pb-20" data-id="element-2335">
        <div className="absolute inset-0" data-id="element-2336">
          <img src="https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=1920&h=1080&fit=crop&auto=format&q=80" alt="Tropical resort with overwater bungalow" className="w-full h-full object-cover" data-id="element-2337" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70" data-id="element-2338"></div>
        </div>

        <div className="relative z-10 text-center px-4 sm:px-6 lg:px-10 max-w-6xl mx-auto py-12 sm:py-20" data-id="element-2339">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white mb-6 sm:mb-8 leading-tight" data-id="element-2340">
            Endless Destinations
          </h2>

          <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl text-white/95 mb-8 sm:mb-12 leading-relaxed max-w-5xl mx-auto px-4" data-id="element-2341">
            Incredible Deals from Independent Hotels and Well-Known Brands. Up
            to 60% Off Great Rooms! Save Big with RaceLookup Exclusive Rates!
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center px-4" data-id="element-2342">
            <Link to="/signin" className="px-8 sm:px-12 py-3 sm:py-4 bg-white text-gray-900 font-bold rounded-xl hover:bg-gray-100 transition-colors shadow-lg text-base sm:text-lg" data-id="element-2343">
              LOGIN
            </Link>
            <Link to="/create-account" className="px-8 sm:px-12 py-3 sm:py-4 bg-gradient-to-r from-[#01AAE7] to-[#0199d6] text-white font-bold rounded-xl hover:from-[#0199d6] hover:to-[#0188c5] transition-all shadow-lg text-base sm:text-lg" data-id="element-2344">
              REGISTER
            </Link>
          </div>
        </div>
      </section>
    </div>;
}